/**
 * Impersonation Banner
 * Shows when SuperAdmin is viewing as a specific company
 */
import React from 'react';
import { X, Eye } from 'lucide-react';
import { useAdmin } from '../../contexts/AdminContext';
import { useAdminCompanies } from '../../hooks/useCompany';

export const ImpersonationBanner: React.FC = () => {
  const { selectedCompanyId, setSelectedCompanyId, isImpersonating } = useAdmin();
  const { data: companies } = useAdminCompanies();

  if (!isImpersonating || !selectedCompanyId) {
    return null;
  }

  const selectedCompany = companies?.items?.find(
    (c) => c.companyId === selectedCompanyId
  );

  const handleDeselect = () => {
    setSelectedCompanyId(null);
  };

  return (
    <div className="bg-gradient-to-r from-yellow-400 to-orange-400 border-b border-yellow-500 shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
              <Eye className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="text-sm font-semibold text-white">
                Viendo como: {selectedCompany?.name || selectedCompanyId}
              </p>
              <p className="text-xs text-white/80">
                Estás impersonando esta empresa. Los datos mostrados son de esta empresa.
              </p>
            </div>
          </div>
          <button
            onClick={handleDeselect}
            className="flex items-center gap-2 px-4 py-2 bg-white/20 hover:bg-white/30 text-white rounded-lg transition-colors font-medium text-sm"
            aria-label="Volver a vista global"
          >
            <X className="w-4 h-4" />
            <span className="hidden sm:inline">Volver a vista global</span>
          </button>
        </div>
      </div>
    </div>
  );
};
